import { useQuery } from '@tanstack/react-query';
import { BotAPIClient } from '@/api/client';
import { useRef } from 'react';
export function useWhaleDetail(version, address) {
    const clientRef = useRef(null);
    if (!clientRef.current || clientRef.current.getVersion() !== version) {
        clientRef.current = new BotAPIClient(version);
    }
    return useQuery({
        queryKey: ['whaleDetail', version, address],
        queryFn: async () => {
            const response = await clientRef.current.getWhaleDetail(address);
            if ('error' in response) {
                throw new Error(response.error);
            }
            return response;
        },
        enabled: address.length > 0,
        staleTime: 60000,
        placeholderData: (prev) => prev,
    });
}
//# sourceMappingURL=useWhaleDetail.js.map